import { useEffect, useRef, useState, } from 'react'
import { useHistory } from 'react-router-dom';

import {
    getProcessButtons, setDateTimeFormatGlobal, getDtRowIndexNew, getError, isUndNullNew, sendMessageCloseCurrentWindow,
    getLanguageObj, getResponse, settings, setBadgeBooleanNew, LoadingSection
} from '../../helpers/UtilsHelper';
import useAuth from '../../auth/useAuth';
import Menu from '../main/Menu';
import { GlobalFormats } from '../../classes/main/globalFormatClass';

import { NotificationToastService } from '../../services/notifications/NotificationToastService';
import TableIndex from '../main/TableIndex';

const $ = window?.$;
const { app, icons, images, messages, labels } = settings;
const { urls } = app?.backend;

const currentMethod = 'NotificationsToast - function';

export default function NotificationsToast({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
} = {}) {
    //#region variables
    const auth = useAuth();
    const history = useHistory();
    const dtNotificationToastId = 'dtNotificationToast';
    const dateTimeFormat = {
        date: languageObj?.format?.date?.f1,
        time: languageObj?.format?.time?.type,
    };

    const [process, setProcess] = useState({ showLoading: false, add: false });
    const isMount = useRef(true);
    //#endregion variables

    //#region methods
    const getData = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            setProcess(prev => ({ ...prev, showLoading: true }));

            //#region dataTable / queryCode
            response = setDataTable({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            response = setQueryCode({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion dataTable / queryCode

            //#region user is admin
            response = checkUserIsAdminLocal({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) {
                history.push(urls?.backend);
                return;
            }
            //#endregion User is admin

            //#region get data (notifications toast)
            const token = auth?.account?.tokenVzLaML?.token;
            response = await NotificationToastService.getAll({ token, subMethod: currentMethod });

            if (!response?.isSuccess || response?.isWarning) return;

            const notificationsLocal = response?.result || [];
            //#endregion get data (notifications toast)

            //#region set dataTable
            let notificationsDtLocal = [];
            if (notificationsLocal?.length > 0) {
                notificationsDtLocal = notificationsLocal.map((detail) => {
                    return [
                        detail?.title,
                        setBadgeBooleanNew({
                            type: detail?.isActive,
                            languageId: languageObj?.id
                        }),
                        setDateTimeFormatGlobal({
                            date: detail?.created,
                            type: dateTimeFormat?.date,
                            format: dateTimeFormat?.time,
                            addTime: false,
                            withSeconds: false,
                            subMethod: currentMethod
                        })?.result,
                        getProcessButtons({
                            id: detail?.id,
                            description: detail?.title,
                            detailsShow: true,
                            detailsLabel: labels?.detail?.[languageObj?.id],
                            detailsEnabled: true,
                            editShow: true,
                            editLabel: labels?.edit?.[languageObj?.id],
                            editEnabled: true,
                            deleteShow: true,
                            deleteLabel: labels?.delete?.[languageObj?.id],
                            deleteEnabled: true,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        })?.result,
                    ];
                });
            }

            $(`#${dtNotificationToastId}`).DataTable().clear().rows.add(notificationsDtLocal).draw(true);
            //#endregion set dataTable
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }

    const setDataTable = ({
        subMethod = '',
    }) => {
        const currentMethod = 'setDataTable';
        let response = getResponse({ type: 0 });
        try {
            $(`#${dtNotificationToastId}`).DataTable({
                destroy: true,
                data: [],
                order: [[1, 'desc']],
                columns: [
                    { title: labels?.title?.[languageObj?.id], width: '55%', },
                    { className: 'text-center', title: labels?.isActive?.[languageObj?.id], width: '10%', },
                    { className: 'text-center', title: labels?.created?.[languageObj?.id], width: '25%', },
                    { className: 'text-center', title: labels?.process?.[languageObj?.id], width: '5%', orderable: false, },
                ],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis'],
            }).buttons().container().appendTo(`#${dtNotificationToastId}_wrapper .col-md-6:eq(0)`);
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const setQueryCode = ({
        subMethod = '',
    }) => {
        const currentMethod = 'setQueryCode';
        let response = getResponse({ type: 0 });
        try {
            $(`#${dtNotificationToastId} tbody`).on('click', 'tr', 'td', async function (e) {
                const rowIndexLocal = getDtRowIndexNew({ dtId: dtNotificationToastId, this_: this, subMethod: currentMethod })?.result;
                if (!isUndNullNew({ data: rowIndexLocal, subMethod: currentMethod, })?.result) {
                    const methodValueLocal = e?.target?.attributes?.method?.value || '';
                    switch (methodValueLocal) {
                        case 'edit':
                            break;
                        case 'detail':
                            break;
                        case 'delete':
                            break;
                        default:
                            break;
                    }
                }
            });
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const checkUserIsAdminLocal = ({
        subMethod = '',
    }) => {
        const currentMethod = 'checkUserIsAdminLocal';
        let response = getResponse({ type: 0 });
        try {
            if (!auth.isLoged()) {
                response = getResponse({ type: 1 });
                response.msgText = `${messages?.youDoNotHaveSufficientPrivilegesToRunThisProcess?.[languageObj?.id]}`;
                return response;
            }
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        getData({
            subMethod: 'form - onLoad',
        });
        return () => {
            isMount.current = false;
        }
    }, []);// eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <div>
            <Menu viewName={'settings'} process={'notificationsToats'} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Premium Bar) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.notificationsToast?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href={urls?.home}>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.notificationsToast?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        <div className='card border-0 shadow-lg login-card' >
                            <LoadingSection alt='loadingSection'
                                className='overlay dark text-white'
                                height={20}
                                hidden={!process?.showLoading}
                                width={20}
                                languageId={languageObj?.id}
                                subMethod={currentMethod} />

                            <div className='card-header bg-white border-0 pt-4 px-4'>
                                <div className='d-flex align-items-center justify-content-between'>
                                    <div className='d-flex align-items-center'>
                                        <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                            style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <img alt='imgRoles'
                                                style={{ width: '25px', height: '25px', objectFit: 'contain' }}
                                                src={images?.icons?.newMessage} />
                                        </div>
                                        <div className='d-flex flex-column'>
                                            <h5 className='mb-0 font-weight-bold text-dark'>{labels?.notifications?.[languageObj?.id]}</h5>
                                            <div className='mt-1'>
                                                <span className='badge badge-pill badge-primary px-2 py-1 text-uppercase' style={settings?.html?.badges?.micro}>
                                                    <i className={`${icons?.fasFa?.list} mr-1`}></i> {labels?.index?.[languageObj?.id]}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <button className='btn btn-primary shadow-sm font-weight-bold px-4 btn-primary'
                                        disabled={process?.showLoading}
                                        onClick={(e) => e?.preventDefault()}
                                        data-title={labels?.add?.[languageObj?.id]}>
                                        {!process?.add ? (
                                            <i className={`${icons?.fasFa?.plusCircle} mr-1`} />
                                        ) : (
                                            <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                        )} {labels?.add?.[languageObj?.id]}
                                    </button>
                                </div>
                            </div>

                            <div className='card-body px-4 pb-4'>
                                <TableIndex tableId={dtNotificationToastId} languageObj={languageObj} />
                            </div>

                        </div>

                    </div>
                </section>

            </div>
        </div>
    )
}